module.exports = __webpack_public_path__ + "static/media/Popup_framing@3x.9e4d5eef.png";